import React from 'react'
import { withKeepAlive } from 'react-next-keep-alive';

import { Layout } from 'antd';
import cn from 'classnames';

import Navbar from '@components/Navbar'
import { useAsideHeight, useAuthSession } from '@lib/hooks'
import HotProjects from '@widget/community/hotProjects'
import HotTopic from '@widget/community/hotTopic'
import RecommendTabs from '@widget/community/recommendTabs'
import TradeLogo from '@widget/community/tradeLogo'
import QuickPost from '@widget/editor/QuickPost'

import styles from '@styles/modules/community/index.module.css';
import community from '@styles/modules/communityTopic.module.css'

const { Header } = Layout

const HotPersonData = () => {
  const isLogin = useAuthSession({ redirectTo: null });
  const { ref } = useAsideHeight()
  return (
    <Layout className={community.pageContCss}>
      <Header>
        <Navbar></Navbar>
      </Header>
      <div className={cn(community.content, styles.main)}>
        <div className={styles.left}>
          {
            isLogin && <QuickPost />
          }
          <RecommendTabs className={styles.recommend} />
        </div>
        <div className={cn(community.hotPersonDataCont, styles.right)} ref={ref}>
          {/* <div className={styles.communityHotComponent}> */}
          <HotProjects />
          <HotTopic />
          <TradeLogo />
          {/* </div> */}
        </div>
      </div>
      {/* <Footer>{I18n.t('layout_footer')}</Footer> */}
    </Layout>
  )
}

export default withKeepAlive(
  HotPersonData,
  'community'
);
